export default function assertInject<T>(key: InjectionKey<T>): T;
export default function assertInject<T, K = Partial<T>>(key: InjectionKey<T>, defaultValue: K, treatDefaultAsFactory?: false): Partial<T> & K;
export default function assertInject<T, K = Partial<T>>(key: InjectionKey<T>, defaultValue: K | (() => K), treatDefaultAsFactory: true): Partial<T> & K;
export default function assertInject(key: InjectionKey<any>, defaultValue?: any, treatDefaultAsFactory?: any) {
  const value = inject(key, defaultValue, treatDefaultAsFactory)
  if (value === undefined) {
    throw new Error(
      `Attempt to inject ${key.description} before it was provided.`
    )
  }

  return value
}